import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";
import { Overline } from "../components/Overline";
import { MEDIA, YOUTUBE } from "../lib/site";
import { Seo } from "../components/Seo";
import { AimaMeaning } from "../components/AimaMeaning";

export default function About() {
  return (
    <div data-testid="page-about" className="bg-[#faf9f6]">
      <Seo title="About Lara" description="Meet Lara Brown, certified by the Mind Body Life Institute. Functional and circadian hormone health for women." path="/about" />
      <section className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16 py-20 md:py-28">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-20 items-start">
          <div className="lg:col-span-5 lg:sticky lg:top-28">
            <div className="arch-image aspect-[4/5] bg-[#cbdad6]">
              <img
                src={MEDIA.portrait}
                alt="Lara Brown"
                className="w-full h-full object-cover"
              />
            </div>
            <p className="mt-6 font-serif text-2xl italic text-[#5fa292]">
              - Lara
            </p>
          </div>
          <div className="lg:col-span-7">
            <Overline>About Lara</Overline>
            <h1 className="font-serif text-5xl md:text-6xl lg:text-7xl tracking-tighter leading-[1.04] font-normal text-[#333] mt-5">
              A practitioner
              <br />
              for the women
              <br />
              <span className="italic">no one listens to.</span>
            </h1>
            <div className="mt-10 space-y-6 text-lg text-[#3d3d3d] font-normal leading-relaxed">
              <p>
                I came into this work the long way round - through my own
                decade of being dismissed. Painful periods, recurrent acne,
                chronic exhaustion, anxiety that felt structural, and a string
                of GPs who handed me the pill, an SSRI, or a shrug.
              </p>
              <p>
                When I finally found functional medicine and circadian health,
                something cracked open. For the first time, someone took my
                whole story seriously. My cycle. My sleep. My nervous system.
                My grief. My morning light exposure. My mineral status. None of
                it was random. All of it was connected.
              </p>
              <p>
                Aima Health is the practice I wish I'd had access to. It is a
                place where women are believed first, and then carefully,
                methodically, supported - with functional testing, with
                circadian and nutritional foundations, with herbal and
                nutraceutical strategy, and with a great deal of patience for
                how long real healing takes.
              </p>
              <p>
                I'm certified by the Mind Body Life Institute, trained in
                functional nutrition and circadian medicine, and committed to
                working only with women. I see clients across the UK and
                internationally, virtually.
              </p>
            </div>

            <div className="mt-12 grid grid-cols-2 sm:grid-cols-3 gap-8 border-t border-[#e5e0d8] pt-10">
              {[
                { label: "Trained in", value: "Functional Nutrition" },
                { label: "Certified by", value: "Mind Body Life Institute" },
                { label: "Specialism", value: "Circadian Hormone Health" },
                { label: "Practice since", value: "2017" },
                { label: "Based in", value: "UK · Online globally" },
                { label: "Works with", value: "Women only" },
              ].map((d) => (
                <div key={d.label}>
                  <p className="text-xs uppercase tracking-[0.2em] text-[#5fa292]">
                    {d.label}
                  </p>
                  <p className="font-serif text-xl text-[#333] mt-2 font-normal">
                    {d.value}
                  </p>
                </div>
              ))}
            </div>

            <Link to="/contact" className="inline-block mt-12" data-testid="about-cta">
              <Button className="bg-[#5fa292] hover:bg-[#4d8275] text-white rounded-full px-8 h-12">
                Work with me
              </Button>
            </Link>
          </div>
        </div>
      </section>

      {YOUTUBE.introVideoId && (
        <section className="py-20 md:py-28 bg-[#f3eee8]/60 border-t border-[#e5e0d8]">
          <div className="max-w-5xl mx-auto px-6 md:px-12 text-center">
            <Overline>Meet me, in motion</Overline>
            <h2 className="font-serif text-4xl md:text-5xl tracking-tight leading-tight font-normal text-[#333] mt-5">
              A short introduction
              <br />
              <span className="italic">to who I am, and how I work.</span>
            </h2>
            <div
              data-testid="about-youtube"
              className="mt-12 rounded-3xl overflow-hidden border border-[#e5e0d8] shadow-xl shadow-[#5fa292]/10 bg-black aspect-video"
            >
              <iframe
                src={`https://www.youtube.com/embed/${YOUTUBE.introVideoId}`}
                title="Meet Lara - Aima Women's Health"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
                className="w-full h-full"
              />
            </div>
            <p className="mt-6 text-sm text-[#3d3d3d] font-normal">
              About 3 minutes. Sound on for the best welcome.
            </p>
          </div>
        </section>
      )}
      <AimaMeaning testId="about-aima-meaning" />
    </div>
  );
}
